import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import ReactDOM from 'react-dom'
import { getEnv } from 'configurations'
import AWS from 'aws-sdk'
import mapboxgl from 'mapbox-gl'
import moment from 'moment'

import DeckGL from '@deck.gl/react'
import ReactMapGL from 'react-map-gl'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { EditableGeoJsonLayer } from '@nebula.gl/layers'
import { PathStyleExtension } from '@deck.gl/extensions'
import { ViewMode, DrawPolygonMode, DrawPointMode, DrawLineStringMode, ModifyMode } from '@nebula.gl/edit-modes'

import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Modal from '@material-ui/core/Modal'

import { Breadcrumb } from 'antd'
import mapLoading from 'assets/map-loading.png'
import LogoTycho from 'assets/logo_tycho.png'
import RedMarker from 'assets/red_marker.png'
import WhiteMarker from 'assets/white_marker.png'

import {
  updateAuthData,
  LOGED_IN,
  LOGED_OUT,
  CHANGE_PASSWORD_CHALLENGE,
  EMAIL_VERIFICATION_CHALLENGE,
} from 'store/auth/auth'

import { setSideBarInfo } from 'store/global/map/sideBarInfo'
import { setSectionSelected } from 'store/global/sectionSelected'
import { setBasemapStyleStore } from 'store/global/map/basemapStyleInfo'
import { appendSubstationsInfo, appendMunicipalityInfo, appendPlantsInfo } from 'store/global/map/finderInfo'
import { appendLayersInfo, appendLayersInfoMapboxLayers, setLayersInfo } from 'store/global/map/layersInfo'

import SideBar from './SideBar/SideBar'
import ToolBar from './Tools/ToolBar'
import StyleSelector from './styleSelector/StyleSelector'
import Infraestructure from './SideBar/toogleMenu/Infraestructure/'
import Legends from './legend/Legend'

import BarChart from './charts/BarChart'
import RpcApiClient from 'datasources/RpcApiClient'
import BitMapLayers from './layers/BitMapLayers.js'
import LayersApi from './layers/LayersApi.js'
import LayerFunctions from './MapFunctions/LayerFunctions'

import './Map.css'

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default

const useStyles = makeStyles((theme) => ({
  circle: {
    color: '#a65e44',
  },
}))

// function Map(props) {
const Map = forwardRef((props, _ref) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()
  const MAPBOX_ACCESS_TOKEN = getEnv('REACT_APP_MAPBOX_TOKEN')
  const [initialViewState, setInitialViewState] = useState({
    latitude: 0,
    longitude: 0,
    bearing: 0,
    pitch: 0,
    zoom: 1,
  })

  const authData = useSelector((state) => state.auth.authData)
  const viewStateData = useSelector((state) => state.viewState.viewStateData)
  const basemapStyle = useSelector((state) => state.basemapStyle.basemapStyleData)
  const basemapName = useSelector((state) => state.basemapStyle.basemapStyleName)
  const sideBarInfo = useSelector((state) => state.sideBarInfo)
  const layersInfo = useSelector((state) => state.layersInfo)
  const finderInfo = useSelector((state) => state.finderInfo)

  const refDeckgl = React.createRef()
  const refMap = React.createRef()

  const [client, setClient] = useState('')
  const [accessModal, setAccessModal] = useState(false)
  const [layer, setLayer] = useState(0)
  const [sidebarData, setSidebarData] = useState([])
  const [sidebarBandera, setSidebarBandera] = useState(false)
  const [clientPlan, setClientPlan] = useState('')
  const [layerCount, setLayerCount] = useState()
  const [layerData, setLayerData] = useState([])
  const [layerDisplayData, setLayerDisplayData] = useState([])
  const [layerBitMap, setLayerBitMap] = useState([])

  const [toggler, setToggler] = useState({ display: 'none', x: -100, y: -100 })
  // const [styles, setStyles] = useState('mapbox://styles/mapbox/satellite-streets-v11')
  const [styles, setStyles] = useState('mapbox://styles/rmstycho/cl2rrcjn5003c15lbbt5urwm2')
  const [rasters, setRasters] = useState({
    solar: 'mapbox://styles/rmstycho/cks4zaepw0u7p18p53elsfrce',
    wind: 'mapbox://styles/rmstycho/cl0u2qgcr001e15pc46tj6rrv',
    slope: 'mapbox://styles/rmstycho/cldchdf1l000801qez0zrs1b5',
  })
  const [s3, setS3] = useState()
  const [hover, setHover] = useState('')
  const [open, setOpen] = useState(false)
  const [openTimeLapse, setOpenTimeLapse] = React.useState(false)

  const [download, setDownload] = useState(false)
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [distance, setDistance] = useState([])

  const [municipality, setMunicipality] = useState([])
  const [plants, setPlants] = useState([])
  const [substations, setSubstations] = useState([])

  const [rasterLoading, setRasterLoading] = useState(true)
  const [rasterlbl, setRasterlbl] = useState('')

  const [solar, setSolar] = useState({ state: false, raster: '' })
  const [solarPolygon, setSolarPolygon] = useState({ state: false, raster: '' })

  const [crossPointer, setCrossPointer] = useState(false)
  const [current, setCurrent] = useState('')

  const [tableData, setTableData] = useState()
  const [chartModal, setChartModal] = useState(false)

  const [mode, setMode] = useState(() => ViewMode)
  const [style, setStyle] = useState({
    lineColor: [40, 40, 40],
    fillColor: [120, 120, 120, 125],
    tentativeLineColor: [236, 236, 236],
    tentativeFillColor: [255, 255, 255, 80],
    pointType: 'circle',
    url: null,
  })
  const [selectedFeatureIndexes, setSelectedFeatureIndexes] = useState([0])
  const [features, setFeatures] = useState({
    type: 'FeatureCollection',
    features: [],
  })

  const [modeRaster, setModeRaster] = useState(() => ViewMode)
  const [styleRaster, setStyleRaster] = useState({
    lineColor: [40, 40, 40],
    fillColor: [120, 120, 120, 125],
    tentativeLineColor: [236, 236, 236],
    tentativeFillColor: [255, 255, 255, 80],
    pointType: 'circle',
    url: null,
  })
  const [featuresRaster, setFeaturesRaster] = useState({
    type: 'FeatureCollection',
    features: [],
  })

  useImperativeHandle(_ref, () => ({
    getLayers: () => {
      return layerData
    },
  }))

  const drawLayer = new EditableGeoJsonLayer({
    id: 'draw-layer',
    data: features,
    mode: mode,
    selectedFeatureIndexes,
    //edit custom points
    getEditHandlePointColor: [255, 0, 0, 200],
    getEditHandlePointOutlineColor: (d) => (style.tentativeLineColor ? style.tentativeLineColor : [236, 236, 236]),
    editHandlePointStrokeWidth: 3,
    //editHandlePointRadiusMaxPixels:8,
    //editHandlePointRadiusMinPixels:4,
    //editHandlePointRadiusScale:1,
    //editHandlePointRadiusUnits: "pixels",
    //editHandlePointStrokeWidth: 2,
    //editHandleType: "point",
    //editHandlePointRadiusScale: 2,
    //getEditHandlePointRadius:5,

    //customize tentative feature style
    getTentativeLineColor: (d) => (style.tentativeLineColor ? style.tentativeLineColor : [255, 255, 255, 80]),
    getTentativeFillColor: (d) => (style.tentativeFillColor ? style.tentativeFillColor : [236, 236, 236]),
    getTentativeLineWidth: 3,

    //geojson styles
    getFillColor: (d) => (style.fillColor ? style.fillColor : [120, 120, 120, 125]),
    getLineColor: (d) => (style.lineColor ? style.lineColor : [40, 40, 40]),
    getLineWidth: 3,
    getRadius: 5,
    // pointType: 'circle',
    pointRadiusMinPixels: 5,
    pointRadiusScale: 1,

    _subLayerProps: {
      geojson: {
        pointType: style.pointType ? style.pointType : 'circle',
        getIcon: (d) => ({
          url: style.url ? style.url : RedMarker,
          width: 128,
          height: 128,
          anchorY: 128,
        }),
        iconSizeMaxPixels: 25,
        iconSizeMinPixels: 25,
        iconSizeUnits: 'pixels',
        getDashArray: [3, 2],
        dashJustified: true,
        extensions: [new PathStyleExtension({ dash: true })],
      },
      guides: {
        pointType: style.pointType ? style.pointType : 'circle',
        getIcon: (d) => ({
          url: style.url ? style.url : RedMarker,
          width: 128,
          height: 128,
          anchorY: 128,
        }),
        iconSizeMaxPixels: 25,
        iconSizeMinPixels: 25,
        iconSizeUnits: 'pixels',
        getDashArray: [3, 2],
        dashJustified: true,
        extensions: [new PathStyleExtension({ dash: true })],
      },
    },
    // onClick:(e)=>{findClick(e.object.geometry)},
    // onHover: (info) => {
    //   info.object = { html: false }
    // },
    onEdit: (event) => {
      handleDraw(event)
    },
  })

  const rasterLayer = new EditableGeoJsonLayer({
    id: 'raster-layer',
    data: featuresRaster,
    mode: modeRaster,
    selectedFeatureIndexes,
    //edit custom points
    getEditHandlePointColor: [255, 0, 0, 200],
    getEditHandlePointOutlineColor: (d) =>
      styleRaster.tentativeLineColor ? styleRaster.tentativeLineColor : [236, 236, 236],
    editHandlePointStrokeWidth: 3,

    //customize tentative feature style
    getTentativeLineColor: (d) =>
      styleRaster.tentativeLineColor ? styleRaster.tentativeLineColor : [255, 255, 255, 80],
    getTentativeFillColor: (d) => (styleRaster.tentativeFillColor ? styleRaster.tentativeFillColor : [236, 236, 236]),
    getTentativeLineWidth: 3,

    //geojson styles
    getFillColor: (d) => (styleRaster.fillColor ? styleRaster.fillColor : [120, 120, 120, 125]),
    getLineColor: (d) => (styleRaster.lineColor ? styleRaster.lineColor : [40, 40, 40]),
    getLineWidth: 3,
    getRadius: 5,
    // pointType: 'circle',
    pointRadiusMinPixels: 5,
    pointRadiusScale: 1,

    _subLayerProps: {
      geojson: {
        pointType: styleRaster.pointType ? styleRaster.pointType : 'circle',
        getIcon: (d) => ({
          url: styleRaster.url ? styleRaster.url : WhiteMarker,
          width: 128,
          height: 128,
          anchorY: 128,
        }),
        iconSizeMaxPixels: 25,
        iconSizeMinPixels: 25,
        iconSizeUnits: 'pixels',
        getDashArray: [3, 2],
        dashJustified: true,
        extensions: [new PathStyleExtension({ dash: true })],
      },
      guides: {
        pointType: styleRaster.pointType ? styleRaster.pointType : 'circle',
        getIcon: (d) => ({
          url: styleRaster.url ? styleRaster.url : WhiteMarker,
          width: 128,
          height: 128,
          anchorY: 128,
        }),
        iconSizeMaxPixels: 25,
        iconSizeMinPixels: 25,
        iconSizeUnits: 'pixels',
        getDashArray: [3, 2],
        dashJustified: true,
        extensions: [new PathStyleExtension({ dash: true })],
      },
    },
    // onClick:(e)=>{findClick(e.object.geometry)},
    // onHover: (info) => {
    //   info.object = { html: false }
    // },
    onEdit: (event) => {
      // setFeaturesRaster(event.updatedData)
      handleDrawRaster(event)
    },
  })

  const handleDraw = (event) => {
    const { editType, updatedData } = event

    if (style.pointType === 'circle') {
      setFeatures(updatedData)
      if (editType === 'addTentativePosition') {
        setDistance([...distance, event.editContext.position])
      } else if (editType === 'finishMovePosition') {
        setDistance(updatedData.features[0].geometry.coordinates)
      } else if (editType === 'addFeature') {
        setDistance(updatedData.features[0].geometry.coordinates)
        !solarPolygon.state ? setMode(() => ModifyMode) : setMode(() => ViewMode)
      }
    } else if (style.pointType === 'icon') {
      if (editType === 'addFeature') {
        setDistance(updatedData.features[0].geometry.coordinates)
        const data = updatedData
        data.features = updatedData.features.slice(-1)
        setFeatures(data)
      }
    }
  }

  const handleDrawRaster = (event) => {
    const { editType, updatedData } = event

    if (styleRaster.pointType === 'circle') {
      setFeaturesRaster(updatedData)
      if (editType === 'addTentativePosition') {
        setDistance([...distance, event.editContext.position])
      } else if (editType === 'finishMovePosition') {
        setDistance(updatedData.features[0].geometry.coordinates)
      } else if (editType === 'addFeature') {
        // console.log('Poly',event)
        setDistance(updatedData.features[0].geometry.coordinates)
        setModeRaster(() => ViewMode)
      }
    } else if (styleRaster.pointType === 'icon') {
      if (editType === 'addFeature') {
        // console.log('point',event)
        setDistance(updatedData.features[0].geometry.coordinates)
        const data = updatedData
        data.features = updatedData.features.slice(-1)
        setFeaturesRaster(data)
      }
    }
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const handleTimeLapse = () => {
    setOpenTimeLapse(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleTooltip = (info) => {
    // setHover(info)
    // console.log(info)
    if (info?.object && info.object.html !== undefined) {
      // console.log(info)
      return {
        html: `<div>${info.object.html}</div>`,
        style: {
          backgroundColor: '#fafcff',
          color: '#000000',
          fontSize: '14px',
          marginLeft: '20px',
          borderLeftStyle: 'solid',
          borderLeftColor: '#d4d9df',
          borderLeftWidth: '6px',
          borderRadius: '5px',
        },
      }
    } else if (info?.object && info.object.properties.id !== undefined) {
      // console.log(info)
      return {
        html: `<div>${info.object.properties.name ? info.object.properties.name : info.object.properties.id}</div>`,
        style: {
          backgroundColor: '#fafcff',
          color: '#000000',
          fontSize: '14px',
          marginLeft: '20px',
          borderLeftStyle: 'solid',
          borderLeftColor: '#d4d9df',
          borderLeftWidth: '6px',
          borderRadius: '5px',
        },
      }
    }
  }

  const handleViewState = (data) => {
    props.setViewState({
      longitude: data.longitude,
      latitude: data.latitude,
      zoom: data.zoom,
      pitch: 0,
      bearing: 0,
    })
  }

  const getDataStructure = async (datastructure) => {
    const response = await RpcApiClient.getDataStructure(authData.jwtToken, datastructure)
    const data = await response

    dispatch(setSideBarInfo(data.data.data))
    let currentSidebarJSON = JSON.parse(JSON.stringify(data.data.data))
    let currentSidebar = [...currentSidebarJSON]
    setSidebarData(currentSidebar)
    setSidebarBandera(true)
  }

  // const getTechnologyLayers = async (technology) => {
  //   let requestBody = {
  //     clients: client,
  //     plans: clientPlan,
  //     technology: '',
  //     managements: props.countrySelected.datastructure.municipality.adminitrative_division,
  //     // managements: props.countrySelected.datastructure.managements ? props.countrySelected.datastructure.managements : [],
  //     // zones: props.countrySelected.datastructure.zones ? props.countrySelected.datastructure.zones : []
  //   }

  //   if ('zones' in props.countrySelected.datastructure) {
  //     requestBody.zones = props.countrySelected.datastructure.zones
  //   }
  //   if ('countries' in props.countrySelected.datastructure) {
  //     requestBody.countries = props.countrySelected.datastructure.countries
  //   }

  //   requestBody.technology = technology
  //   const response = await RpcApiClient.getPowerplants(authData.jwtToken, requestBody)
  //   const data = await response

  //   setLayerData((layerData) => [...layerData, data.data.body])
  //   // props.setLayerDataR((layerData) => [...layerData, data.data.body])
  //   let newResponseJSON = JSON.parse(JSON.stringify(data.data.body))
  //   // console.log(newResponseJSON)
  //   // let newResponse = [...newResponseJSON]
  //   dispatch(appendLayersInfo(newResponseJSON))
  //   setPlants((plants) => plants.concat(data.data.body.data))

  //   let currentFinderJSON = JSON.parse(JSON.stringify(data.data.body.data))
  //   let currentFinder = [...currentFinderJSON]
  //   dispatch(appendPlantsInfo(currentFinder))
  // }

  const getRasterData = async (geom, lon_r, lat_r, polygon, basemap, count) => {
    let requestBody = {
      type: geom,
      lon: lon_r,
      lat: lat_r,
      polygonData: polygon,
      bm: basemap,
      client: client,
    }

    if ('countries' in props.countrySelected.datastructure) {
      requestBody.country = props.countrySelected.datastructure.countries[0]
    }

    const response = await RpcApiClient.getRasters(authData.jwtToken, requestBody)
    const data = await response
    if (geom === 'point') {
      return data.data.body
    } else {
      return data.data.body.avg
    }
  }

  const getMunicipalityList = async () => {
    let requestBody = {
      client: client,
      country: props.countrySelected.datastructure.countries,
    }

    const response = await RpcApiClient.getMunicipality(authData.jwtToken, requestBody)
    const data = await response
    setMunicipality(data.data.body)

    let currentFinderJSON = JSON.parse(JSON.stringify(data.data.body))
    let currentFinder = [...currentFinderJSON]
    dispatch(appendMunicipalityInfo(currentFinder))
  }

  const getPlantsList = (list) => {
    let data = []
    list.map((obj) => data.push(obj.data))
    const concatList = [].concat.apply([], data)
    setPlants(concatList)
    dispatch(appendPlantsInfo(concatList))
  }

  const getSubList = (list) => {
    let data = []
    list.map((obj) => data.push(obj.data))
    const concatList = [].concat.apply([], data)
    setSubstations(concatList)
    dispatch(appendSubstationsInfo(concatList))
  }

  useEffect(() => {
    document.addEventListener('contextmenu', (event) => {
      event.preventDefault()
    })
    if ('plan' in props.countrySelected) {
      setClientPlan(props.countrySelected.plan)
    } else {
      setClientPlan('basic')
    }

    if ('datastructure' in props.countrySelected) {
      // console.log("Hay estructura de datos")
      const datastructure = props.countrySelected.datastructure
      getDataStructure(datastructure)
    }

    // if(layersInfo){
    //   let currentLayerStateStoredJSON = JSON.parse(JSON.stringify(layersInfo))
    //   let currentLayerState = { ...currentLayerStateStoredJSON }
    //   setLayerDisplayData(currentLayerState)
    // }

    if (viewStateData != initialViewState && !props.viewState) {
      let currentInitialViewStateStoredJSON = JSON.parse(JSON.stringify(viewStateData))
      let currentInitialViewState = { ...currentInitialViewStateStoredJSON }
      setInitialViewState((initialViewState) => currentInitialViewState)
    }
    if (props.viewState) {
      setInitialViewState(props.viewState)
    }
    if ('rasters' in props.countrySelected) {
      setRasters({
        solar: props.countrySelected.rasters.solar,
        wind: props.countrySelected.rasters.wind,
        slope: props.countrySelected.rasters.slope ? props.countrySelected.rasters.slope : null,
      })
    }
    if (basemapStyle.trim() !== '') {
      setStyles(basemapStyle)
      if (basemapName.trim() === '') bitmapToggle(true)
      if (basemapName === 'satelite') bitmapToggle(true)
      if (basemapName === 'dark') bitmapToggle(false)
      if (basemapName === 'light') bitmapToggle(false)
      if (basemapName === 'streets') bitmapToggle(false)
      if (basemapName === 'outdoors') bitmapToggle(false)
      if (basemapName === 'slope') bitmapToggle(false)
      if (basemapName === 'wind') bitmapToggle(false)
      if (basemapName === 'solar') bitmapToggle(false)
    } else if (basemapStyle.trim() === '') {
      bitmapToggle(true)
    }
    if (props.user_tools) {
      if (!props.user_tools.includes('layers')) {
        setAccessModal(true)
      }
    }
  }, [])

  useEffect(() => {
    if (sidebarData.length && sidebarBandera && client) {
      //console.log(sidebarData)
      if (!layersInfo.data.length) {
        setPlants([])
        setSubstations([])
        getMunicipalityList()
        LayerFunctions.readLayers(
          sidebarData,
          sidebarBandera,
          client,
          layersInfo,
          props.countrySelected.datastructure,
          authData.jwtToken,
          clientPlan,
        ).then((values) => {
          // setLayerData((layerData) => [...layerData, values])
          const plants = values.filter((layerType) => layerType.layer === 'powerplants')
          const substations = values.filter((layerType) => layerType.layer === 'substations')
          getPlantsList(plants)
          //setPlants(LayerFunctions.getList(plants))
          getSubList(substations)
          //setSubstations(LayerFunctions.getList(substations))
          setLayerData((layerData) => layerData.concat(values))
          let newResponseJSON = JSON.parse(JSON.stringify(values))
          dispatch(appendLayersInfo(newResponseJSON))
          setLoadingFlag(true)
        })
      } else {
        let currentLayersInfoStoredJSON = JSON.parse(JSON.stringify(layersInfo))
        let currentLayersInfo = [...currentLayersInfoStoredJSON.data]
        setLayerData((layerData) => currentLayersInfo)

        setMunicipality(finderInfo.municipality)
        setSubstations(finderInfo.substations)
        setPlants(finderInfo.plants)
        setLoadingFlag(true)
      }
    }
  }, [sidebarBandera])

  useEffect(() => {
    if (layerData.length) {
      setLayerDisplayData(LayersApi(layerData))
    }
  }, [layerData])

  useEffect(() => {
    dispatch(setBasemapStyleStore(styles))
  }, [styles])

  useEffect(() => {
    // console.log("Change: ", props.countrySelected)
    setSidebarBandera(false)
    setClient('')
    setClientPlan('')
    setClient(props.countrySelected.client)
    setSidebarData([])
    setLayerData([])
    if (basemapStyle.trim() !== '') {
      setStyles(basemapStyle)
      if (basemapName.trim() === '') bitmapToggle(true)
      if (basemapName === 'satelite') bitmapToggle(true)
      if (basemapName === 'dark') bitmapToggle(false)
      if (basemapName === 'light') bitmapToggle(false)
      if (basemapName === 'streets') bitmapToggle(false)
      if (basemapName === 'outdoors') bitmapToggle(false)
      if (basemapName === 'slope') bitmapToggle(false)
      if (basemapName === 'wind') bitmapToggle(false)
      if (basemapName === 'solar') bitmapToggle(false)
    } else if (basemapStyle.trim() === '') {
      setLayerBitMap(BitMapLayers(true))
    }

    if ('map_location' in props.countrySelected && !props.viewState) {
      setInitialViewState({
        bearing: parseFloat(props.countrySelected.map_location.bearing),
        latitude: parseFloat(props.countrySelected.map_location.latitude),
        longitude: parseFloat(props.countrySelected.map_location.longitude),
        pitch: parseFloat(props.countrySelected.map_location.pitch),
        zoom: parseFloat(props.countrySelected.map_location.zoom),
      })
    } else {
      // setInitialViewState({
      //   bearing: 0,
      //   latitude: 0,
      //   longitude: 0,
      //   pitch: 0,
      //   zoom: 3,
      // })
      setInitialViewState(props.viewState)
    }

    if ('plan' in props.countrySelected) {
      setClientPlan(props.countrySelected.plan)
    } else {
      setClientPlan('basic')
    }

    if (!sideBarInfo.data.length) {
      if ('datastructure' in props.countrySelected) {
        const datastructure = props.countrySelected.datastructure
        getDataStructure(datastructure)
        //LayerFunctions.getDataStructure (datastructure,authData,setSideBarInfo,setSidebarData,setSidebarBandera)
      }
    }

    if ('rasters' in props.countrySelected) {
      // console.log(props.countrySelected.map_location.country)
      setRasters({
        solar: props.countrySelected.rasters.solar,
        wind: props.countrySelected.rasters.wind,
        slope: props.countrySelected.rasters.slope ? props.countrySelected.rasters.slope : null,
      })
    }
    setLoadingFlag(false)
    setDistance([])
    setCrossPointer(false)
    setSolar({ state: false, raster: '' })
    setSolarPolygon({ state: false, raster: '' })
    if (basemapStyle.trim() !== '') {
      setStyles(basemapStyle)
    } else {
      setStyles('mapbox://styles/rmstycho/cl2rrcjn5003c15lbbt5urwm2')
    }
  }, [props.countrySelected])

  // useEffect(() => {
  // console.log(layerDisplayData)
  // }, [loadingFlag])

  const bitmapToggle = (bool) => {
    setLayerBitMap(BitMapLayers(bool))
  }

  const Selected = (info) => {
    // console.log(info)
    let newArr = [...sidebarData]
    // console.log(newArr.filter(val=> val.title === data.title)[0])
    for (var i = 0; i < sideBarInfo.data.length; i++) {
      newArr[i].show = false
    }
    setSidebarData(newArr)

    if (solar.state) {
      setRasterLoading(false)
      setRasterlbl('Loading')
      getRasterData('point', info.coordinate[0], info.coordinate[1], [], solar.raster).then((val) => {
        val === undefined || val === null ? setRasterlbl('No Data Available') : setRasterlbl(val.toFixed(2))
        setRasterLoading(true)
      })
    }

    if (solarPolygon.state) {
      if (distance[0][0].toString() === distance[0].slice(-1)[0].toString()) {
        setRasterLoading(false)
        setRasterlbl('Loading')
        getRasterData('polygon', info.coordinate[0], info.coordinate[1], distance[0], solarPolygon.raster).then(
          (val) => {
            val === undefined || val === null ? setRasterlbl('No Data Available') : setRasterlbl(val.toFixed(2))
            setRasterLoading(true)
          },
        )
        // setSolarPolygon({ state: false, raster: '' })
      }
    }

    // if (info?.object && !areaActive && !windActivePolygon && !solarActivePolygon) {
    if (info?.object && info.object.html !== undefined) {
      setTableData()
      if (info.object.chartData !== undefined) setTableData(info.object.chartData)
      if (info.x > 1056) setToggler({ display: 'block', x: -280, y: -100 })
      if (info.y < 100) setToggler({ display: 'block', x: -100, y: 0 })
      if (info.x > 1056 && info.y < 100) setToggler({ display: 'block', x: -280, y: -0 })
      if (info.y > 100 && info.x < 1056) setToggler({ display: 'block', x: -100, y: -100 })
      setHover(info)
      const display = info.object.html
      ReactDOM.render(display, document.getElementById('show'))
      setS3(info.object.html.key)
    }

    if (!info?.object) {
      setToggler({ display: 'none', x: -100, y: -100 })
    }
  }

  const close = () => {
    setToggler({ display: 'none', x: -100, y: -100 })
  }

  const handleDownload = async () => {
    if (!refMap.current || !refDeckgl.current) {
      return
    }

    const blob = await new Promise((resolve) => {
      const mapGL = refMap.current.getMap()
      const deck = refDeckgl.current.deck

      const mapboxCanvas = mapGL.getCanvas()
      deck.redraw(true)
      const deckglCanvas = deck.canvas

      let merge = document.createElement('canvas')
      merge.width = mapboxCanvas.width
      merge.height = mapboxCanvas.height

      let context = merge.getContext('2d')

      context.globalAlpha = 1.0
      context.drawImage(mapboxCanvas, 0, 0)
      context.globalAlpha = 1.0
      context.drawImage(deckglCanvas, 0, 0)

      merge.toBlob(resolve, 'image/jpeg', 0.5)
    })

    // merge.toBlob((img) => {
    //   setBlob(img)
    // });
    return blob
  }

  const modalBody = (
    <div className="modal-pdf">
      <div className="modal-title-container">
        <h2 className="diagram-title">Oneline Diagram</h2>
        <CloseIcon
          style={{ fontSize: '25px', right: '10px', top: '10px', cursor: 'pointer', position: 'fixed' }}
          onClick={() => handleClose()}
        />
      </div>
      <iframe src={s3 + '#toolbar=0'} frameBorder="0" className="diagram-iframe"></iframe>
    </div>
  )

  const timeLapseBody = (
    <div className="modal-pdf" style={{ width: '570px', height: 'fit-content' }}>
      <div className="modal-title-container" style={{ marginBottom: '20px' }}>
        <h2 className="diagram-title">Time-Lapse</h2>
        <CloseIcon
          style={{ fontSize: '25px', right: '10px', top: '10px', cursor: 'pointer', position: 'fixed' }}
          onClick={() => setOpenTimeLapse(false)}
        />
      </div>
      <div style={{ display: 'flex' }}>
        <img style={{ margin: 'auto', marginBottom: '20px', width: '454px', borderRadius: '5px' }} src={s3} />
      </div>
    </div>
  )

  const noAccessModal = (
    <div className="denied-container">
      <div style={{ display: 'grid' }}>
        <h2 className="denied-title">ACCESS DENIED</h2>
        <p className="denied-content">You don't have access to the Layer module.</p>
        <p className="denied-content">In case this is a mistake, please contact our support team.</p>
        <button
          className="denied-btn"
          onClick={() => {
            dispatch(setSectionSelected('GEOCREATOR'))
            history.push('/')
          }}
        >
          RETURN
        </button>
      </div>
    </div>
  )

  if (Object.keys(props.countrySelected || {}).length === 0) {
    return <div> Please select a country</div>
  }

  if (loadingFlag && sidebarBandera) {
    return (
      <div style={{ height: '100%' }}>
        <Breadcrumb className="map-title">
          <Breadcrumb.Item>Scope</Breadcrumb.Item>
          <Breadcrumb.Item>{props.countrySelected.country}</Breadcrumb.Item>
        </Breadcrumb>

        <div className="map-container" style={{ backgroundImage: `url(${mapLoading})` }}>
          <div
            style={{
              overflow: 'hidden',
              height: '100%',
              width: '100%',
            }}
          >
            <div>
              <div>
                <ToolBar
                  sidebarData={sidebarData}
                  layer={layer}
                  distance={distance}
                  setDistance={setDistance}
                  download={download}
                  setDownload={setDownload}
                  municipality={municipality}
                  setInitialViewState={setInitialViewState}
                  plants={plants}
                  substations={substations}
                  handleDownload={handleDownload}
                  map={props.countrySelected.country}
                  setMode={setMode}
                  setStyle={setStyle}
                  setFeatures={setFeatures}
                  setCrossPointer={setCrossPointer}
                  current={current}
                  setCurrent={setCurrent}
                />

                <SideBar sidebarData={sidebarData} setSidebarData={setSidebarData} setLayer={setLayer} />

                <Infraestructure
                  sidebarData={sidebarData}
                  setSidebarData={setSidebarData}
                  clientName={client}
                  layer={layer}
                  layerData={layerData}
                  setLayerData={setLayerData}
                  setInitialViewState={setInitialViewState}
                  country={props.countrySelected.datastructure.countries[0]}
                />

                <Legends sidebarData={sidebarData} layerData={layerData} />

                <StyleSelector
                  setStyles={setStyles}
                  setDistance={setDistance}
                  rasterLoading={rasterLoading}
                  rasterlbl={rasterlbl}
                  setRasterlbl={setRasterlbl}
                  solar={solar}
                  setSolar={setSolar}
                  solarPolygon={solarPolygon}
                  setSolarPolygon={setSolarPolygon}
                  bitmapToggle={bitmapToggle}
                  rasters={rasters}
                  country={props.countrySelected.map_location.country}
                  setModeRaster={setModeRaster}
                  setStyleRaster={setStyleRaster}
                  setFeaturesRaster={setFeaturesRaster}
                  current={current}
                  setCurrent={setCurrent}
                />

                <div
                  className="on-click"
                  style={{
                    display: `${toggler.display}`,
                    left: hover.x + toggler.x,
                    top: hover.y + toggler.y,
                    zIndex: '2',
                    marginBottom: '50px',
                  }}
                >
                  <div style={{ color: 'black', height: '20px', display: 'flex' }}>
                    <label className="on-click-title">Info</label>
                    <CloseIcon
                      style={{
                        fontSize: '19px',
                        position: 'relative',
                        margin: 'auto',
                        right: '-107px',
                        cursor: 'pointer',
                      }}
                      onClick={() => close()}
                    />
                  </div>
                  <div id="show" className="info-container"></div>
                  {tableData !== undefined ? (
                    <div className="onClick-popup" onClick={() => setChartModal(true)}>
                      Chart
                    </div>
                  ) : null}
                  {s3 === null || s3 === 'null' ? null : s3 !== undefined && s3.includes('pdf') ? (
                    <div className="onClick-popup" onClick={handleOpen}>
                      Oneline Diagram
                    </div>
                  ) : (
                    <div className="onClick-popup" onClick={handleTimeLapse}>
                      Time-Lapse
                    </div>
                  )}
                </div>

                <Modal open={open} onClose={handleClose}>
                  {modalBody}
                </Modal>

                <Modal open={openTimeLapse} onClose={() => setOpenTimeLapse(false)}>
                  {timeLapseBody}
                </Modal>

                <Modal open={accessModal}>{noAccessModal}</Modal>

                <BarChart
                  chartModal={chartModal}
                  setChartModal={setChartModal}
                  chartData={tableData}
                  showLegend={false}
                />

                <DeckGL
                  ref={refDeckgl}
                  initialViewState={initialViewState}
                  onDragEnd={(e) => handleViewState(e.viewport)}
                  useDevicePixels={false}
                  pickingRadius={2}
                  controller={true}
                  layers={[layerBitMap, layerDisplayData, drawLayer, rasterLayer, props.geoLayer]}
                  getTooltip={handleTooltip}
                  getCursor={({ isHovering, isDragging }) =>
                    isHovering
                      ? 'pointer'
                      : crossPointer || solar.state || solarPolygon.state
                      ? 'crosshair'
                      : isDragging
                      ? 'grabbing'
                      : 'grab'
                  }
                  onClick={Selected}
                  width="100%"
                  height="100%"
                  style={{ overflow: 'hidden' }}
                  // onError={(err) => (err.message.includes('Failed to fetch resource') ? null : null)}
                  onError={(err) => console.log(err.message)}
                >
                  <ReactMapGL
                    ref={refMap}
                    preserveDrawingBuffer={true}
                    mapboxApiAccessToken={MAPBOX_ACCESS_TOKEN}
                    mapStyle={styles}
                    preventStyleDiffing={true}
                  />
                </DeckGL>
                <img src={LogoTycho} className="logo-tycho" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="main-container" style={{ overflow: 'hidden', backgroundColor: '#f0f2f5' }}>
        <div style={{ margin: 'auto', backgroundColor: '#f0f2f5' }}>
          <div
            style={{ width: '10%', left: '50%', marginTop: '25%', position: 'relative', backgroundColor: '#f0f2f5' }}
          >
            <CircularProgress className={classes.circle} />
            <h3 className="load-label">Loading map...</h3>
          </div>
        </div>
      </div>
    )
  }
})
export default Map
